import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client'
import { globalAjaxLoaderStore } from '@Stores';
import App from './App'
import './index.css'

const renderCallback = () => {
    const loader = document.getElementById('react-app-loader');
    const message = document.getElementById('react-app-loader-message');
    if (loader && message) {
        globalAjaxLoaderStore.appLoaderElement = loader;
        globalAjaxLoaderStore.appLoaderMessageElement = message;
        loader.addEventListener(
            'transitionend',
            () => {
                if (loader.classList.contains('hide')) {
                    loader.classList.add('invisible');
                }
            },
            true
        );
    }
};

createRoot(document.getElementById('react-app')!).render(
  <BrowserRouter>
    <App callback={renderCallback}/>
  </BrowserRouter>
)
